type DayOption = {
  label: string;
  value: string;
  disabled: boolean;
};

export const applyRestrictedWeekDays = (
  days: DayOption[],
  restrictedWeekDays: string[] | null | undefined
): DayOption[] => {
  if (!restrictedWeekDays || restrictedWeekDays.length === 0) {
    // si no hay restricción, ninguno está disabled
    return days.map((day) => ({
      ...day,
      disabled: false,
    }));
  }

  const allowedSet = new Set(restrictedWeekDays);

  return days.map((day) => ({
    ...day,
    disabled: !allowedSet.has(day.value),
  }));
};
